import {
  AritoFormV2,
  AritoIcon,
  AritoInputTable,
  Button,
  type DataTableColumn,
  DialogV2
} from '@/components/custom/erp';

export interface BulkError {
  index: number;
  field: string;
  error: string;
}

interface BulkErrorDialogProps {
  open: boolean;
  onClose: () => void;
  errors: BulkError[];
}

type BulkErrorColumn = DataTableColumn & {
  sortable?: boolean;
};

const columns: BulkErrorColumn[] = [
  {
    headerName: 'Nội dung lỗi',
    field: 'message',
    sortable: false,
    width: 400
  },
  {
    headerName: 'Loại',
    field: 'type',
    width: 120,
    sortable: false,
    align: 'center'
  },
  {
    headerName: 'Vị trí',
    field: 'position',
    width: 120,
    sortable: false,
    align: 'center'
  }
];

export const BulkErrorDialog = ({ open, onClose, errors }: BulkErrorDialogProps) => {
  const errorRows = errors.map((error, idx) => ({
    id: `${error.index}-${idx}`,
    type: error.field,
    message: error.error,
    position: `Dòng ${error.index + 2}`
  }));

  return (
    <DialogV2 open={open} onClose={onClose} title='Chi tiết kết quả Import' maxWidth='lg'>
      <div className='flex flex-col gap-4'>
        <AritoFormV2
          mode='add'
          hasAritoActionBar={false}
          className='h-auto min-w-[725px]'
          headerFields={
            <div className='flex flex-col gap-2'>
              <AritoInputTable columns={columns} value={errorRows} mode='view' tableActionButtons={['export']} />
            </div>
          }
          bottomBar={
            <Button onClick={onClose} variant='outline'>
              <AritoIcon icon={885} className='mx-1' />
              Đóng
            </Button>
          }
        />
      </div>
    </DialogV2>
  );
};
